import React, { useEffect, useRef, useState } from "react"
import { Col, Row } from "reactstrap"
import {
  arrayPush,
  change,
  FieldArray,
  formValueSelector,
  getFormSyncErrors,
  resetSection,
} from "redux-form"
import { connect } from "react-redux"
import { sendInvites, openInactiveEventWarningModal } from "store/actions"
import { SaveButton } from "components/Buttons"
import { renderUsers } from "../utils"
import { FORM_NAMES } from "constants/index"
import XLSX from "xlsx"

const AddUsersManually = ({
  vendorId,
  arrayPush,
  change,
  resetSection,
  usersList,
  selectedEvent,
  sendInvites,
  formSyncErrors,
  openInactiveEventWarningModal,
  eventInviteListSortOptions,
}) => {
  const CSVFile = useRef(null)
  const [showResetUsersListButton, setShowResetUsersListButton] =
    useState(false)

  useEffect(() => {
    setShowResetUsersListButton(
      usersList?.filter(object =>
        object
          ? (Object.hasOwn(object, "first_name") && object.first_name !== "") ||
            (Object.hasOwn(object, "last_name") && object.last_name !== "") ||
            (Object.hasOwn(object, "email") && object.email !== "")
          : false
      )?.length > 0
    )
  }, [usersList])

  const handleResetUsersList = () => {
    setShowResetUsersListButton(false)
    resetSection(FORM_NAMES.EXPERIENCE, "permissions.users")
  }

  const handleCSVUpload = event => {
    const { files } = event.target
    if (files.length > 0) {
      const reader = new FileReader()
      reader.onload = ({ target: { result } }) => {
        const wb = XLSX.read(result, { type: "binary" })
        let users = []
        Object.keys(wb.Sheets).forEach(key => {
          const sheet = XLSX.utils.sheet_to_json(wb.Sheets[key], {
            header: ["first_name", "last_name", "email"],
          })
          users = [...users, ...sheet]
        })
        change(FORM_NAMES.EXPERIENCE, "permissions.users", users)
        event.target.value = ""
        event.target.files = null
      }
      reader.readAsBinaryString(files[0])
    }
  }

  const grantAccessHandler = sendInvite => {
    if (!formSyncErrors?.permissions?.users) {
      sendInvites(
        {
          invites: usersList
            .map(user =>
              user?.email
                ? {
                    first_name: user.first_name ? user.first_name : "",
                    last_name: user.last_name ? user.last_name : "",
                    email: user.email,
                    event_id: selectedEvent.id,
                    type: 0,
                    vendor_id: vendorId,
                  }
                : null
            )
            .filter(user => user),
          send: sendInvite,
          send_app_invite: false,
        },
        eventInviteListSortOptions,
        vendorId,
        selectedEvent.id
      )
      handleResetUsersList()
    }
  }

  const grantAccessAndInviteHandler = () => {
    if (!formSyncErrors?.permissions?.users) {
      if (selectedEvent.published === false) {
        openInactiveEventWarningModal()
      } else {
        grantAccessHandler(true)
      }
    }
  }

  return (
    <Row className="mt-2">
      <Col xs={12}>
        <h5>
          Add Users Manually -&nbsp;
          <span style={{ fontWeight: "normal" }}>
            Make this experience visible to users by adding them manually or by
            CSV upload
          </span>
        </h5>
      </Col>

      <Col xs={12} className="mb-1 mx-3 my-3">
        <span>Bulk User Upload &nbsp;</span>
        <SaveButton
          type="button"
          content="Upload CSV"
          onClick={() => CSVFile.current.click()}
        />
        <input
          ref={CSVFile}
          type="file"
          name="csvFile"
          onChange={handleCSVUpload}
          accept=".xlsx,.xls,.csv,.ods"
          className="d-none"
        />
      </Col>
      {showResetUsersListButton && (
        <Col xs={12} className="my-1 mx-3">
          <SaveButton
            type="button"
            content="Clear List"
            onClick={handleResetUsersList}
            color="danger"
          />
        </Col>
      )}
      <Col xs={12} className="mx-3">
        <FieldArray name="users" component={renderUsers} />
      </Col>
      <Row className="mx-2">
        <Col md={4} xl={7} className="mb-1">
          <SaveButton
            type="button"
            content="+ new line"
            onClick={() =>
              arrayPush(FORM_NAMES.EXPERIENCE, "permissions.users", null)
            }
            color="light"
          />
        </Col>
        <Col sm={6} md={3} xl={2} className="mb-1">
          <SaveButton
            type="button"
            content="Grant Access"
            onClick={() => grantAccessHandler(false)}
            fullWidth={true}
            disabled={!showResetUsersListButton}
          />
        </Col>
        <Col sm={6} md={5} xl={3} className="mb-1">
          <SaveButton
            type="button"
            content="Grant Access & Send Email Invite"
            onClick={grantAccessAndInviteHandler}
            fullWidth={true}
            disabled={!showResetUsersListButton}
          />
        </Col>
      </Row>
    </Row>
  )
}

const selector = formValueSelector(FORM_NAMES.EXPERIENCE)

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  usersList: selector(state, "permissions.users"),
  selectedEvent: state.experiences.selectedEvent,
  formSyncErrors: getFormSyncErrors(FORM_NAMES.EXPERIENCE)(state),
  eventInviteListSortOptions: state.experiences.eventInviteListSortOptions,
})

const mapDispatchToProps = dispatch => ({
  arrayPush: (form, field, value) => dispatch(arrayPush(form, field, value)),
  change: (form, field, value) => dispatch(change(form, field, value)),
  resetSection: (form, section) => dispatch(resetSection(form, section)),
  sendInvites: (params, sortOptions, vendorId, eventId) =>
    dispatch(sendInvites(params, sortOptions, vendorId, eventId)),
  openInactiveEventWarningModal: () =>
    dispatch(openInactiveEventWarningModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddUsersManually)
